"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconFuelPump = function IconFuelPump(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m23.427 11.427-1.414-1.414-5.15 5.15-.136.145a3 3 0 0 0 .136 4.1l5.3 5.3.705-.706-.714.716.113.124a1.91 1.91 0 0 1-.113 2.58 1.91 1.91 0 0 1-2.706.002l-.698.696.697-.697L14 21.976V16l-.005-.217A5 5 0 0 0 9 11H5v2h4l.176.005A3 3 0 0 1 12 16v27h2V24.804l4.032 4.032v.001l.161.152a3.91 3.91 0 0 0 5.375-.153 3.91 3.91 0 0 0 0-5.533l.01-.01-3.988-3.987a3.5 3.5 0 0 0 .774-4.816zm-3.467 5.514a2.5 2.5 0 0 1-1.087 1.648l-.596-.596-.087-.1a1 1 0 0 1 .087-1.315l1.365-1.365a2.5 2.5 0 0 1 .318 1.728m14.023 9.89-8.063-7.685-1.38 1.448 8.515 8.115 9.218 1.469.123.027a1.11 1.11 0 0 1 .79 1.266l-.86 4.626-.028.118a1.11 1.11 0 0 1-1.06.785H37.9a5.002 5.002 0 0 0-9.8 0H17v2h11.1a5.002 5.002 0 0 0 9.8 0h3.34l.186-.006a3.11 3.11 0 0 0 2.867-2.53l.86-4.631.03-.207a3.1 3.1 0 0 0-.55-2.149l-.126-.166a3.1 3.1 0 0 0-1.918-1.108zM33 35a3 3 0 1 1 0 6 3 3 0 0 1 0-6m-1.5 3a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0M25 36v-1h-4v1zM7.54 24.54a5 5 0 0 1 1 2.28l-.07.06a2.08 2.08 0 0 1-4.15.18v-.24a5 5 0 0 1 1-2.28q.459-.71 1-1.36l.14-.18.08.18q.539.652 1 1.36",
    clipRule: "evenodd"
  })));
};

export { IconFuelPump, IconFuelPump as default };
